<template>
  <div>
    <Layout :pagetitle="$t('Partner')">
      <Table
        :title="$t('Partner')"
        :items="partnerTable"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="true"
        :searchable="true"
        :editable="true"
        :removable="true"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editPartner"
        @onCreate="createPartner"
        @onRemove="onRemove"
        @onChangePage="changePage"
      />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'level',
          label: this.$t('Level')
        },
        {
          key: 'token',
          label: 'Token'
        },
        {
          key: 'percentage',
          label: this.$t('Percentage')
        },
        {
          key: 'calculation',
          label: this.$t('Calculation')
        }
      ],
      partners: []
    };
  },
  mounted() {
    this.getPartners();
  },
  methods: {
    createPartner() {
      this.$router.push({
        name: 'partnerCreate'
      });
    },
    changePage(page) {
      this.page = page;
      this.getPartners();
    },
    getPartners() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/partner', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.partners = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    editPartner(partner) {
      this.$router.push({
        name: 'partnerUpdate',
        params: {
          id: partner.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getPartners();
    },
    onRemove(partner) {
      this.$api.destroy(`api/partner/${partner.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('Partner was excluded with success')
        });
        this.getPartners();
      });
    }
  },
  computed: {
    partnerTable() {
      return this.partners.map((pl) => {
        return {
          ...pl,
          level: `${this.$t('Level')} ${pl.level}`,
          percentage: `${parseFloat(pl?.reward?.percentage || 0) * 100}%` || '',
          calculation: pl?.reward?.calculation || ''
        };
      });
    }
  }
};
</script>

<style></style>
